import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  public currentTabIndex = 0;
  private _dataStream = new BehaviorSubject({});

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataStream(): Observable<any> {
    return this._dataStream.asObservable();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  putDataToStream(data: any): void {
    this._dataStream.next(data);
  }
}
